import translate from '@translate';
import { TableColumnType } from 'src/types/table';
import { getRowShipperServiceKey } from 'src/utils/shipperServiceFilter';

export const REQUIRED_ORDERS_GRID_COLUMNS = [
    'ESHOP_ORDER_ID',
    'ID',
    'TRACKING_NUMBER',
    'SHIPPER',
    'STATUS',
    'ORDER_TYPE',
    'SOURCE_SYS',
];
export const REQUIRED_ORDERS_GRID_ALL_PROVIDERS_COLUMNS = [...REQUIRED_ORDERS_GRID_COLUMNS, 'ESHOP_KEY'];

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'orderId',
        type: 'id',
        defaultShow: true,
    },
    {
        key: 'PARENT_ORDER_ID',
        label: 'parentOrderId',
        defaultShow: false,
    },
    {
        key: 'ESHOP_ORDER_ID',
        label: 'eshopId',
        type: 'id',
        defaultShow: true,
    },
    {
        key: 'PARENT_ESHOP_ORDER_ID',
        label: 'parentEshopId',
        defaultShow: false,
    },
    {
        key: 'TIMESTAMP',
        label: 'date',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'RECIPIENT_NAME',
        label: 'recipientName',
        defaultShow: true,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'INVOICE_NUMBER',
        label: 'invoiceNumber',
        defaultShow: true,
    },
    {
        key: 'INVOICE_DATE',
        label: 'invoiceDate',
        type: 'date',
    },
    {
        key: 'PAYMENT_METHOD',
        label: 'paymentMethod',
        type: 'select',
        selectOption: 'paymentCodes',
    },
    {
        key: 'PAID',
        label: 'paid',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'SHIPPER',
        label: 'shipper',
        type: 'select',
        selectOption: 'shipperCodes',
        defaultShow: true,
    },
    {
        key: 'SHIPPER_SERVICE_CODE',
        label: 'shipperServiceCode',
        type: 'select',
        selectOption: 'shipperServiceCodes',
        selectOptionKeyFce: (row) => getRowShipperServiceKey(row, 'SHIPPER', 'SHIPPER_SERVICE_CODE'),
    },
    {
        key: 'TRACKING_NUMBER',
        label: 'trackingNumber',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'PRINT_RETURN_LABEL',
        label: 'returnLabel',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'RETURN_TRACKING_NUMBER',
        label: 'returnTrackingNumber',
        customRender: true,
        defaultShow: false,
    },
    {
        key: 'EXCHANGE_TRACKING_NUMBER',
        label: 'exchangeTrackingNumber',
        customRender: true,
        defaultShow: false,
    },
    {
        key: 'STATUS',
        label: 'status',
        type: 'select',
        selectOption: 'orderStatusCodes',
        customRender: true,
        defaultShow: true,
        customStyle: { padding: '1px 1px 1px 1px' },
        optionStyleFce: true,
    },
    {
        key: 'INCORRECT_ORDER_MESSAGE',
        label: 'incorrectMessage',
        defaultShow: true,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'SLA_DATE',
        label: 'slaDate',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'ALLOW_EXPEDITION',
        label: 'allowExpedition',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: true,
    },
    {
        key: 'RELEASE_FROM_SUSPENDED_AT',
        label: 'releaseFromSuspendedAt',
        type: 'dateTime',
    },
    {
        key: 'PREORDER_RELEASE_AT',
        label: 'preorderReleaseAt',
        type: 'dateTime',
    },
    {
        key: 'WAITING_FOR_SHIPMENT_AT',
        label: 'waitingForShipmentAt',
        type: 'dateTime',
    },
    {
        key: 'SHIPMENT_ORDERED_AT',
        label: 'shipmentOrderAt',
        type: 'dateTime',
    },
    {
        key: 'IN_PROCESS_AT',
        label: 'inProcessAt',
        type: 'dateTime',
    },
    {
        key: 'SCANNED_AT',
        label: 'scannedAt',
        type: 'dateTime',
    },
    {
        key: 'PACKED_AT',
        label: 'packedAt',
        type: 'dateTime',
    },
    {
        key: 'WAITING_FOR_CARRIER_AT',
        label: 'waitingForCarrierAt',
        type: 'dateTime',
    },
    {
        key: 'REQUIRED_EXPEDITION_DATE',
        label: 'requiredExpeditionDate',
        type: 'date',
    },
    {
        key: 'SHIPPED_AT',
        label: 'shippedAt',
        type: 'dateTime',
    },
    {
        key: 'AT_PICKUP_POINT_AT',
        label: 'atPickupPointAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'DELIVERED_AT',
        label: 'deliveredAt',
        type: 'dateTime',
    },
    {
        key: 'RETURNING_BACK_AT',
        label: 'returningBackAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'RETURNED_BACK_AT',
        label: 'returnedBackAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'CANCELED_AT',
        label: 'canceledAt',
        type: 'dateTime',
    },
    {
        key: 'LAST_STATUS_CHECK_AT',
        label: 'lastStatusCheckAt',
        type: 'dateTime',
    },
    {
        key: 'UPDATED_AT',
        type: 'dateTime',
        label: 'updatedAt',
    },
    {
        key: 'PRICE',
        label: 'price',
        type: 'number-filter',
        defaultShow: true,
    },
    {
        key: 'SHIPPING_PRICE',
        label: 'shippingPrice',
        type: 'number-filter',
    },
    {
        key: 'CURRENCY',
        label: 'currency',
        type: 'select',
        selectOption: 'currencyCodes',
    },
    {
        key: 'COD_PRICE',
        label: 'codPrice',
        type: 'number-filter',
    },
    {
        key: 'COD_CURRENCY',
        label: 'codCurrency',
        type: 'select',
        selectOption: 'currencyCodes',
    },
    {
        key: 'COD_REF_NUMBER',
        label: 'codRefNumber',
    },
    {
        key: 'PARTNER_ORDER_ID',
        label: 'partnerOrderId',
    },
    {
        key: 'WEIGHT',
        label: 'weight',
        type: 'number-filter',
    },
    {
        key: 'ORDER_BOX_COUNT',
        label: 'orderBoxCount',
        type: 'number-filter',
    },
    {
        key: 'BRANCH_ID',
        label: 'branchId',
    },
    {
        key: 'TRANSPORT_PAID_BY_SKLADON',
        label: 'transportPaidBySkladon',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'MESSAGE',
        label: 'message',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'HOLD_BY_QUALITY',
        label: 'holdByQuality',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'PICK_FROM_CUSTOMS_WAREHOUSE',
        label: 'pickFromCustomsWarehouse',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'UNDER_SANCTION',
        label: 'underSanction',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'ADDRESS_ID',
        label: 'addressId',
    },
    {
        key: 'SOURCE_SYS',
        label: 'sourceSys',
    },
    {
        key: 'NOTE',
        label: 'note',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'ESHOP_NOTE',
        label: 'eshopNote',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'PRINT_FILES',
        label: 'printFiles',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'DISABLE_SHIPPING_REORDER',
        label: 'disableShippingReorder',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'MARKETPLACE',
        label: 'marketplace',
        type: 'select',
        selectOption:'orderMarketplacesCodes',
    },
    {
        key: 'ORDER_TYPE',
        label: 'orderType',
        type: 'select',
        selectOption: 'orderTypeCodes',
    },
    {
        key: 'RECIPIENT_ATTENTION_NAME',
        label: 'recipientAttentionName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },

    {
        key: 'RECIPIENT_EMAIL',
        label: 'recipientEmail',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_PHONE',
        label: 'recipientPhone',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_STREET',
        label: 'recipientStreet',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_CITY',
        label: 'recipientCity',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_STATE',
        label: 'recipientState',
        type: 'select',
        selectOption: 'countryOptionsCodes',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_PROVINCE_CODE',
        label: 'recipientProvinceCode',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_POST_CODE',
        label: 'recipientPostCode',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
        label: 'recipientAddressAdditionalInfo',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_COMPANY_NAME',
        label: 'recipientCompanyName',
    },
    {
        key: 'RECIPIENT_COMPANY_ID',
        label: 'recipientCompanyId',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_TAX_ID',
        label: 'recipientTaxId',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'RECIPIENT_GLN',
        label: 'recipientGln',
        defaultShow: false,
    },
    {
        key: 'BILLING_NAME',
        label: 'billingName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_ATTENTION_NAME',
        label: 'billingAttentionName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_EMAIL',
        label: 'billingEmail',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_PHONE',
        label: 'billingPhone',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_STREET',
        label: 'billingStreet',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_CITY',
        label: 'billingCity',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_STATE',
        label: 'billingState',
        type: 'select',
        selectOption: 'countryOptionsCodes',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_PROVINCE_CODE',
        label: 'billingProvinceCode',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_POST_CODE',
        label: 'billingPostCode',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_ADDRESS_ADDITIONAL_INFO',
        label: 'billingAddressAdditionalInfo',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_COMPANY_NAME',
        label: 'billingCompanyName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_COMPANY_ID',
        label: 'billingCompanyId',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_TAX_ID',
        label: 'billingTaxId',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'BILLING_GLN',
        label: 'billingGln',
        defaultShow: false,
    },
];

export const allColumnsWithProvider: TableColumnType[] = [
    {
        key: 'providerName',
        label: 'providerName',
        allwaysShow: true,
        forceFirst: true,
        disableFilter: true,
        disableSort: true,
    },
    ...allColumns,
];

export const extendProductColumns: TableColumnType[] = [
    { key: 'SKU', label: 'productSKU' },
    { key: 'NAME', label: 'productName' },
    { key: 'EAN', label: 'productEAN' },
    { key: 'PRODUCT_PRICE', label: 'productPrice' },
    { key: 'COUNT', label: 'productCount' },
    { key: 'CONFIRMED', label: 'productConfirmed' },
    { key: 'MISSING_COUNT', label: 'productMissingCount' },
    { key: 'SERIAL_NUMBER', label: 'productSerialNumber' },
];

export const extendProductSummarizedColumns: TableColumnType[] = [
    { key: 'COUNT', label: 'productCount' },
    { key: 'CONFIRMED', label: 'productConfirmed' },
    { key: 'MISSING_COUNT', label: 'productMissingCount' },
];


export { ClaimAllowedOrderStatuses as CREATE_CLAIM_STATUSES } from 'skladon-types';
export const CREATE_RETURN_STATUSES = ['onTheWay', 'atPickupPoint', 'delivered', 'returnedBack', 'returningBack', 'lost'];

export const TABS = [
    { value: 'all', label: translate('orders.allOrders') },
    { value: 'b2c', label: translate('orders.b2cOordes') },
    { value: 'b2b', label: translate('orders.b2bOordes') },
    { value: 'transfer', label: translate('orders.transferOrders') },
    { value: 'cod', label: translate('orders.codOrders') },
    { value: 'expedition_packages', label: translate('orders.expeditionPackages') },
    { value: 'messages_on_expedition_box', label: translate('orders.messagesOnExpeditionBox') },
];
